import { createFileRoute } from '@tanstack/react-router';
import { useTranslations } from 'use-intl';
import { AuthLayout } from '@/components/auth/AuthLayout';
import { PasswordResetForm } from '@/components/auth/PasswordResetForm';
import { redirectIfSignedIn } from '@/lib/use-session';

export const Route = createFileRoute('/auth/password-reset')({
  beforeLoad: ({ context }) => redirectIfSignedIn(context),
  component: PasswordResetPage,
});

function PasswordResetPage() {
  const t = useTranslations('Auth');
  return (
    <AuthLayout
      kicker={t('passwordReset.kicker')}
      headline={t('passwordReset.headline')}
    >
      <PasswordResetForm />
    </AuthLayout>
  );
}
